export function buildApiAssetUrl(value, apiBase = '/api') {
  if (!value) return '';
  if (/^https:\/\//i.test(value)) return value;
  if (value.startsWith('/api/')) return value;
  return `${apiBase}${value}`;
}
